import { Skeleton, Spacer } from "@fullscript/aviary-web";

import { SkeletonOrSection } from "../OrSection/SkeletonOrSection";

interface Props {
  isOrTextRendered?: boolean;
}
const SkeletonGoogleSSOButton = ({ isOrTextRendered }: Props) => {
  if (!isOrTextRendered) return null;

  return (
    <>
      <Spacer />
      <Skeleton variant="button" size="medium" width={160} />
      <Spacer />
      <SkeletonOrSection />
      <Spacer />
    </>
  );
};

export { SkeletonGoogleSSOButton };
